import { render } from "./SkillExtension.vue?vue&type=template&id=7ff9e102"
const script = {}
script.render = render

export default script